/* =====================================================================
   LATAKAN - core.js  (socle commun home + catalogue)
   Utils + panier persistant (localStorage) + tiroir partagé + toast + badges.
   À charger AVANT le JS de page. Expose window.LatakanCart + window.LatakanCore.
   ===================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var el = function (h) { var t = document.createElement('template'); t.innerHTML = h.trim(); return t.content.firstElementChild; };
  var eur = function (n) { return (Number(n) || 0).toFixed(2).replace('.', ',') + ' €'; };
  var FREE_SHIP = 60, FLOC_PRICE = 0;

  /* ----------------------------- store (localStorage) ----------------- */
  var KEY = 'latakan_cart_v1';
  var items = [];
  try { items = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { items = []; }
  if (!Array.isArray(items)) items = [];
  items = items.filter(function (l) { return l && typeof l === 'object'; }).map(function (l) {
    l.qty = Math.max(1, parseInt(l.qty, 10) || 1); l.price = Number(l.price) || 0; return l;
  });
  var subs = [];
  function save() { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} subs.forEach(function (f) { try { f(); } catch (e) {} }); }
  function sig(fl) { return fl ? [fl.name, fl.num, fl.bottom, fl.badge].join('|') : ''; }
  function count() { return items.reduce(function (n, l) { return n + l.qty; }, 0); }
  function total() { return items.reduce(function (s, l) { return s + (l.price + (l.floc ? FLOC_PRICE : 0)) * l.qty; }, 0); }
  function add(p) {
    var s = sig(p.floc);
    var line = items.filter(function (l) { return l.id === p.id && l.size === p.size && (l._sig || '') === s; })[0];
    if (line) line.qty++;
    else items.push({ id: p.id, variantId: p.variantId || null, title: p.title, img: p.img || '', price: Number(p.price) || 0, size: p.size || 'Unique', qty: 1, floc: p.floc || null, _sig: s });
    save();
  }
  var Cart = { items: items, count: count, total: total, add: add, save: save, FREE_SHIP: FREE_SHIP, FLOC_PRICE: FLOC_PRICE,
    subscribe: function (f) { subs.push(f); return f; } };

  /* ----------------------------- wishlist (localStorage) -------------- */
  /* Store partage entre la boutique (catalogue) et la page wishlist.       */
  /* Identite stable = team|imgk|season|type|player -> sync coeur partout.  */
  var WKEY = 'latakan_wishlist_v1', WSEED = 'latakan_wishlist_seeded_v1';
  function jpath(team, imgk) { return 'assets/jerseys/' + team + '__' + imgk + '.jpg'; }
  function wkey(o) { return [o.team, o.imgk, o.season, o.type, o.player || ''].join('|'); }
  var WISH_SEED = [];
  var wlist = null;
  try { wlist = JSON.parse(localStorage.getItem(WKEY)); } catch (e) { wlist = null; }
  if (!Array.isArray(wlist)) {
    if (!localStorage.getItem(WSEED)) { wlist = WISH_SEED.slice(); try { localStorage.setItem(WSEED, '1'); localStorage.setItem(WKEY, JSON.stringify(wlist)); } catch (e) {} }
    else wlist = [];
  }
  wlist = wlist.filter(function (x) { return x && x.id; });
  var WSET = new Set(wlist.map(function (x) { return x.id; }));
  var wsubs = [];
  function wsave() { try { localStorage.setItem(WKEY, JSON.stringify(wlist)); } catch (e) {} WSET = new Set(wlist.map(function (x) { return x.id; })); wsubs.forEach(function (f) { try { f(); } catch (e) {} }); }
  var Wish = {
    items: function () { return wlist; },
    has: function (id) { return WSET.has(id); },
    count: function () { return wlist.length; },
    availableCount: function () { return wlist.filter(function (x) { return x.stock !== 'out'; }).length; },
    value: function () { return wlist.reduce(function (s, x) { return s + (Number(x.price) || 0); }, 0); },
    add: function (o) { if (!o || !o.id || WSET.has(o.id)) return false; if (o.addedAt == null) o.addedAt = Date.now(); wlist.push(o); wsave(); return true; },
    remove: function (id) { var n = wlist.length; wlist = wlist.filter(function (x) { return x.id !== id; }); if (wlist.length !== n) wsave(); },
    toggle: function (o) { if (WSET.has(o.id)) { this.remove(o.id); return false; } this.add(o); return true; },
    clear: function () { wlist = []; wsave(); },
    subscribe: function (f) { wsubs.push(f); return f; }
  };

  /* ----------------------------- toast -------------------------------- */
  var toastEl, toastT;
  function toast(title, sub, head) {
    head = head || 'Ajouté au panier';
    if (!toastEl || !document.body.contains(toastEl)) {
      toastEl = $('#toast') || el('<div class="toast" id="toast" hidden role="status" aria-live="polite"></div>');
      if (!toastEl.parentNode) document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="toast__ic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg></span><span class="toast__txt"><b>' + head + '</b><span>' + title + (sub ? ' · ' + sub : '') + '</span></span>';
    toastEl.hidden = false; requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); setTimeout(function () { toastEl.hidden = true; }, 300); }, 2500);
  }

  /* ----------------------------- focus trap --------------------------- */
  var lastFocus = null;
  function focusables(c) { return $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', c).filter(function (e) { return e.offsetParent !== null; }); }
  function trap(c) {
    lastFocus = document.activeElement;
    var f = focusables(c); if (f[0]) f[0].focus();
    c._trap = function (e) {
      if (e.key === 'Escape') { closeCart(); return; }
      if (e.key !== 'Tab') return;
      var ff = focusables(c), first = ff[0], last = ff[ff.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    c.addEventListener('keydown', c._trap);
  }
  function release(c) { if (c && c._trap) c.removeEventListener('keydown', c._trap); if (lastFocus && lastFocus.focus) lastFocus.focus(); }

  /* ----------------------------- drawer ------------------------------- */
  var drawer, scrim, wired = false;
  function ensureDrawer() {
    drawer = $('#cart');
    if (!drawer) {
      scrim = el('<div class="cart-scrim" id="cartScrim"></div>');
      drawer = el('<aside class="cartd" id="cart" role="dialog" aria-modal="true" aria-label="Ton panier"><div class="cartd__head"><h2 class="cartd__title">Ton panier</h2><button class="cartd__close" id="cartClose" type="button" aria-label="Fermer le panier">&times;</button></div><div class="cartd__body" id="cartBody"></div><div class="cartd__foot" id="cartFoot" hidden></div></aside>');
      document.body.appendChild(scrim); document.body.appendChild(drawer);
    } else { scrim = $('#cartScrim'); }
    if (!wired) {
      wired = true;
      var cl = $('#cartClose'); if (cl) cl.addEventListener('click', closeCart);
      if (scrim) scrim.addEventListener('click', closeCart);
    }
  }
  function render() {
    var cb = $('#cartBody'), foot = $('#cartFoot'); if (!cb) return;
    if (!items.length) { cb.innerHTML = '<div class="cart__empty"><p>Ton panier est vide.</p><span>Ajoute un maillot pour le retrouver ici.</span></div>'; if (foot) foot.hidden = true; return; }
    if (foot) foot.hidden = false; cb.innerHTML = '';
    items.forEach(function (l, idx) {
      var unit = l.price + (l.floc ? FLOC_PRICE : 0);
      var media = l.img ? '<img src="' + l.img + '" alt="' + l.title + '" loading="lazy">' : '<span class="cart__ph"></span>';
      var flocLabel = '';
      if (l.floc) {
        var ft = [(l.floc.name || '').trim(), (l.floc.num !== '' && l.floc.num != null) ? l.floc.num : '', (l.floc.bottom || '').trim()].filter(function (x) { return x !== ''; }).join(' ');
        var parts = [];
        if (ft) parts.push('Flocage : ' + ft);
        if (l.floc.badge) parts.push('Écusson ' + l.floc.badge);
        if (parts.length) flocLabel = '<span class="cart__floc">' + parts.join(' · ') + '</span>';
      }
      var row = el('<div class="cart__line"><div class="cart__thumb">' + media + '</div><div class="cart__info"><span class="cart__name">' + l.title + '</span><span class="cart__meta">Taille ' + l.size + '</span>' + flocLabel + '<div class="cart__qty"><button class="cart__step" type="button" data-a="dec" aria-label="Diminuer la quantité">-</button><span>' + l.qty + '</span><button class="cart__step" type="button" data-a="inc" aria-label="Augmenter la quantité">+</button></div></div><div class="cart__right"><span class="cart__lprice">' + eur(unit * l.qty) + '</span><button class="cart__rm" type="button" aria-label="Retirer ' + l.title + '">&times;</button></div></div>');
      $('[data-a=dec]', row).addEventListener('click', function () { if (l.qty > 1) l.qty--; else items.splice(idx, 1); save(); render(); });
      $('[data-a=inc]', row).addEventListener('click', function () { l.qty++; save(); render(); });
      $('.cart__rm', row).addEventListener('click', function () { items.splice(idx, 1); save(); render(); });
      cb.appendChild(row);
    });
    if (!foot) return;
    var t = total(), remain = Math.max(0, FREE_SHIP - t), onCart = /panier\.html$/.test(location.pathname);
    foot.innerHTML = '<div class="cart__ship">' + (remain > 0 ? 'Plus que <b>' + eur(remain) + '</b> pour la livraison offerte' : 'Livraison offerte débloquée') + '</div><div class="cart__bar"><span style="width:' + Math.min(100, t / FREE_SHIP * 100) + '%"></span></div><div class="cart__sub"><span>Sous-total</span><b>' + eur(t) + '</b></div><button class="cart__checkout" type="button">' + (onCart ? 'Payer' : 'Aller au paiement') + '</button><button class="cart__cont" type="button">Continuer mes achats</button><div class="cart__trust"><span><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Paiement sécurisé</span><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5M18 4v3h-3M20 12a8 8 0 0 1-14 5M6 20v-3h3"/></svg>Retours 30j</span></div>';
    $('.cart__cont', foot).addEventListener('click', closeCart);
    $('.cart__checkout', foot).addEventListener('click', latakanCheckout);
  }
  function openCart() { ensureDrawer(); render(); drawer.classList.add('is-open'); if (scrim) scrim.classList.add('is-on'); document.body.classList.add('is-locked'); trap(drawer); }
  function closeCart() { if (!drawer || !drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-on'); document.body.classList.remove('is-locked'); release(drawer); }

  /* ----------------------------- badges ------------------------------- */
  function syncBadges() {
    var n = count();
    $$('#cartCount,#tabCartCount').forEach(function (b) {
      b.textContent = n; b.classList.toggle('is-on', n > 0);
      if (b.id === 'cartCount' && b.animate && n > 0) b.animate([{ transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 240, easing: 'cubic-bezier(.22,.61,.36,1)' });
    });
  }
  subs.push(syncBadges);
  function syncWish() {
    var n = Wish.count();
    var wc = $('#wishCount'); if (wc) { wc.textContent = n; wc.hidden = n === 0; }
    var wb = $('#wishBtn'); if (wb) wb.classList.toggle('is-on', n > 0);
    $$('#tabFavDot').forEach(function (d) { d.hidden = n === 0; });
  }
  wsubs.push(syncWish);

  /* ----------------------------- wire (delegation) -------------------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('#cartBtn');
    if (c) {
      e.preventDefault();
      openCart(); return;
    }
    var w = e.target.closest && e.target.closest('#wishBtn,[data-go="wishlist"]');
    if (w) {
      e.preventDefault();
      if (!/\/pages\/wishlist/.test(location.pathname)) window.location.href = '/pages/wishlist';
    }
  });
  function syncAll() { syncBadges(); syncWish(); }
  if (document.readyState !== 'loading') syncAll();
  else document.addEventListener('DOMContentLoaded', syncAll);

  /* ----------------------------- checkout Shopify (bridge) ------------- */
  function latakanCheckout() {
    var lines = items.map(function (l) {
      var props = {};
      if (l.floc) {
        if (l.floc.name) props['Nom'] = l.floc.name;
        if (l.floc.num !== '' && l.floc.num != null) props['Numéro'] = String(l.floc.num);
        if (l.floc.bottom) props['Texte du bas'] = l.floc.bottom;
        if (l.floc.badge) props['Écusson'] = l.floc.badge;
      }
      return { id: l.variantId, quantity: l.qty, properties: props };
    }).filter(function (i) { return i.id; });
    if (!lines.length) { window.location.href = '/cart'; return; }
    fetch('/cart/clear.js', { method: 'POST' }).then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }) });
    }).then(function () { window.location.href = '/checkout'; }).catch(function () { window.location.href = '/cart'; });
  }

  window.LatakanCart = Cart;
  window.LatakanWish = Wish;
  window.LatakanCore = { $: $, $$: $$, el: el, eur: eur, toast: toast, openCart: openCart, closeCart: closeCart };
})();
